import type { LatLongPoint } from '@apps/main/new-desktop/modules/newMaps';

import type {
  AccommodationType,
  FullStars,
} from '@libs/trip-planner-interfaces';

export interface ActivitySelectionDestinationData {
  destinationText: string;
  numberOfNights?: number;
  filtersPanelActive: boolean;
  activeFiltersAmount: number;
}

export interface ActivitySelectionCardData {
  activitySelectionCardContent: ActivitySelectionCardContentData;
  imageUrls: string[];
  activityCode: string;
  isSelected: boolean;
  activityType: ActivityType;
  position: LatLongPoint;
}

export interface ActivitySelectionCardContentData {
  title: string;
  subtitle: string;
  stars: FullStars;
  content: string[];
  price: string;
  freeCancellation: boolean;
}

export interface ActivitySelectionListData {
  data: ActivitySelectionCardData;
  id: number;
}

export interface ActivitySelectionGridData {
  data: ActivitySelectionListData[];
  id: number;
}

export const enum ActivitySelectionViewType {
  List = 'list',
  Filters = 'filters',
  Map = 'map',
}

export type ActivityType = AccommodationType.Ticket | AccommodationType.Golf;
